import { useQuery } from '@apollo/client';
import { GET_PRO } from '@gql/pros';
import { FeatureNames } from '@utils/permissions';
import { sumBy, uniqBy } from 'lodash';

export const useJobOfferCredits = (proId: string) => {
    const { data } = useQuery(GET_PRO, {
        variables: { proId: proId },
        fetchPolicy: 'cache-first',
        nextFetchPolicy: 'cache-first',
        skip: !proId,
    });
    const pro = data?.getPro;
    const allCredits = (pro?.planCredits || [])?.find(item => item.key === FeatureNames.TOTAL_JOBS_CREDITS)?.credits;

    // Filter out expired credits by checking validUntil date
    const flattenCredits = allCredits?.filter(item => {
        if (!item.validUntil) return true; // Keep credits with no expiration date
        return new Date(item.validUntil) > new Date(); // Keep credits that haven't expired yet
    });

    const maxCredits = sumBy(
        flattenCredits?.filter(item => item.configuration.maximum !== -1),
        'configuration.maximum',
    );
    const usedCredits = sumBy(flattenCredits, 'configuration.used');
    const isInfinite = flattenCredits?.some(item => item.configuration.maximum === -1);
    const stillHasCredits = isInfinite || usedCredits < maxCredits;
    // check if flattenCredits is contains multiple .planName
    const hasMultiplePlanName = uniqBy(flattenCredits, 'planName').length > 1;

    return {
        maxCredits,
        hasMultiplePlanName,
        credits: flattenCredits || [],
        usedCredits,
        isInfinite,
        stillHasCredits,
    };
};
